import "./css/TextButton.css";

import { Button, ButtonProps } from "@mui/material";

import { disableInput } from "./Utility";

export const TextButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      className="textButton"
      onMouseDown={disableInput}
      onTouchStart={disableInput}
      variant={"contained"}
      {...props}
    >
      {props.children}
    </Button>
  );
};
